// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wFiqp","col":"styles_col__24nxT"};